import BaseLayout from 'src/layouts/BaseLayout'
import { Flex, Input, Stack } from '@chakra-ui/react'
import SearchCell from 'src/components/SearchCell'
import SupportLoginCell from 'src/components/SupportLoginCell'
import { useState, useRef, useEffect } from 'react'
import { useDebounce } from 'use-debounce'
import { useHotkeys } from 'react-hotkeys-hook'
import hotkeys from 'src/lib/hotkeys'

// supportLoginUrl
const SupportPage = ({ id }) => {
  const [query, setQuery] = useState('')
  const handleChange = (e) => setQuery(e.target.value)
  const [finalQuery] = useDebounce(query, 400)
  const searchInput = useRef(null)
  useEffect(() => searchInput.current.focus())
  useHotkeys(hotkeys.searchInput, () => searchInput.current.focus(), {
    keyup: true,
  })
  return (
    <BaseLayout>
      <Flex justifyContent="center" m={5}>
        {!id ? (
          <Stack minW={840}>
            <Input
              placeholder="Enter any email, id or name to find possible people/schools [ / ]"
              autoFocus // eslint-disable-line jsx-a11y/no-autofocus
              ref={searchInput}
              value={query}
              onChange={handleChange}
            />
            <SearchCell query={finalQuery} />
          </Stack>
        ) : (
          <SupportLoginCell id={id} />
        )}
      </Flex>
    </BaseLayout>
  )
}

export default SupportPage
